<template>
  <div class=" h-screen w-full bg-gray-300" >
    <div >
      <div class="flex flex-col w-full pl-4" >

          <div class="w-full pb-3 text-gray-900 text-2xl font-bold" style="margin-top:50px">Solicitud de borrado de datos</div>
          <div class="d-flex justify-content-start" >
			  <p>Para solicitar que se borren todos sus datos de la plataforma <b>MiApptsil</b>, publicada por el Laboratorio Nacional de Geointeligencia (GeoInt),  por favor, siga los siguientes pasos
			  </p>
			  <p><br></p>
			  

  			<div class="w-full pb-3 text-gray-900 text-1xl font-bold">Desde la app móvil</div>

<div style="text-align: left; padding-left:50px">        
				<p>
          <li>Inicie sesión en la aplicación con su usuario y contraseña.</li>
          <li>En el menú seleccione "Mi perfil"</li>
          <li>En la información de su perfil vaya hasta la parte de abajo y verá un botón "Borrar cuenta".</li>
          <li>Al hacer clic en el botón "Borrar cuenta" se le mostrará una ventana de advertencia/confirmación de que se eliminará su cuenta.</li>
          <li>En un plazo no mayor de 48 horas se eliminará su cuenta y todos los registros asociados a ella, inluyendo los archivos multimedia que haya subido.</li>  
				</p>
</div>


<br>
<br>

			 <div class="w-full pb-3 text-gray-900 text-1xl font-bold">Solicitud por correo</div>

				Alternativamente, puede solicitar el borrado de datos mediente correo electrónico.

				<p><br></p>

  <div style="text-align: left; padding-left:50px">
    <p >
          <li>Envíe un correo a la dirección miapptsil@gmail.com con el asunto "Solicitud de borrado de datos".</li>
          <li>En el cuerpo del correo, por favor, especifique el correo electrónico con el que se registró en la aplicación.</li>
          <li>(Opcional) Especifique en el cuerpo del correo el motivo por el cual desea dejar de participar en la plataforma.</li>
          <li>En un plazo no mayor de 48 horas un administrador se pondrá en contacto con usted.</li>
          <li>Cuando el administrador se comunique le hará unas preguntas de verificación para asegurar que es el dueño de la cuenta a borrar.</li>
          <li>Una vez confirmada la pertenencia de la cuenta se procederá a dar de baja del sistema.</li>
          <li>En un plazo no mayor de 48 horas se eliminará su cuenta y todos los registros asociados a ella, inluyendo los archivos multimedia que haya subido.</li>      
    </p>
  </div>

				
<!-- 				<div class="w-full pb-3 text-gray-900 text-1xl font-bold">Permisos de la aplicación</div>
				<p>
				La app requiere de ciertos permisos para su correcto funcionamiento, los cuales deben ser concedidos por el usuario. Estos permisos son: <br>
				- Acceso al almacenamiento: Para acceder a imágenes guardadas en la galería y poder subirlas al servidor. <br>
				- Acceso al micrófono y cámara: Para poder grabar audio y video que puedar servir de evidencia de patrimonios culturales. <br>
				- Acceso al GPS: para conocer la ubicación de donde se encuentre un patrimonio cultural. <br>
				</p>
 -->


			<p><br></p>
			
<!-- 			<div class="w-full pb-3 text-gray-900 text-1xl font-bold">Uso de la información recogida</div>
			
			<p>
			La App emplea la información con el fin de proporcionar el mejor servicio posible, particularmente para mantener un registro de usuarios. <br>
            Centro Geoestá altamente comprometido para cumplir con el compromiso de mantener su información segura. Regularmente se monitorea la seguridad para asegurar que no existan accesos no autorizados. <br>
            Centro Geo no venderá, cederá ni distribuirá la información personal que es recopilada sin su consentimiento. <br>
            Centro Geo se reserva el derecho de cambiar los términos de la presente Política de Privacidad en cualquier momento.
			
			</p> -->
			

          </div>


         

      </div>
    </div>

  </div>
</template>

<style scoped>
</style>

<script>
import { mapState, mapActions } from "vuex";


export default {
  data() {
    return {
      email: "",
      password: "",
      showResetPasswordModal: false,
    };
  },
  components: {

  },
  computed: {

  },
  methods: {

  }
};
</script>
